export enum BacktestState {
  REPLACE = 1,
  FIRSTFETCH = 2,
  UNSHIFT = 3,
  DELETE = 4
}

export enum BacktestStatus {
  RUNNING = 0,
  COMPLETED = 1,
  PROGRESS = 2,
  PENDING = 3
}
